"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.off = exports.on = void 0;
var on = function (type, handler) {
    var frameTalkClient = require('../packages/frame-talk-client-pc/index.js');
    frameTalkClient.addEventListener(type, handler);
};
exports.on = on;
var off = function (type, handler) {
    var frameTalkClient = require('../packages/frame-talk-client-pc/index.js');
    frameTalkClient.removeEventListener(type, handler);
};
exports.off = off;
